import React from "react";
import PropTypes from "prop-types";

import {
  DrawerHeaderCloseContainerWrapper,
  DrawerHeaderContainerWrapper,
  DrawerHeaderTitleContainerWrapper,
  DrawerHeaderTitleWrapper
} from "./DrawerHeaderWrapper";
import SVGIconV3 from "../../SVGIcon/SVGIconV3";

const DrawerHeader = props => {
  return (
    <DrawerHeaderContainerWrapper>
      <DrawerHeaderTitleContainerWrapper>
        <DrawerHeaderTitleWrapper>{props.text}</DrawerHeaderTitleWrapper>
      </DrawerHeaderTitleContainerWrapper>
      <DrawerHeaderCloseContainerWrapper
        position={props.closeIconPosition}
        onClick={props.onCloseClick}
      >
        <SVGIconV3
          iconName={props.closeIconName}
          rotation={props.closeIconRotation}
          data-testid={props.closeDataTestId}
          color="white"
          height="1.8rem"
          width="1.8rem"
        ></SVGIconV3>
      </DrawerHeaderCloseContainerWrapper>
    </DrawerHeaderContainerWrapper>
  );
};

DrawerHeader.propTypes = {
  text: PropTypes.string,
  closeIconName: PropTypes.string,
  closeIconPosition: PropTypes.string.isRequired,
  closeIconRotation: PropTypes.string,
  closeDataTestId: PropTypes.string,
  onCloseClick: PropTypes.func
};

export default React.memo(DrawerHeader);
